import { Modal } from 'antd';
import Qs from 'qs'
import Cookies from 'js-cookie'

import {createBrowserHistory} from 'history'
// model
import  { CommonTree } from 'galaxy-framework'
import KeyValue from '@/model/common/keyValue'
// 埋点数据
import ETBaseDataModel from '@/eventTracking/model/baseData'
import MediaExtradata from '@/eventTracking/model/mediaExtradata'

const {confirm} = Modal
const history = createBrowserHistory()


// 确认动作
const confirmOperate = ({title, content,okText="确认",cancelText="取消", okType, onOk}) => {
    confirm({
        title,
        content,
        okText,
        cancelText,
        okType,
        onOk() {
            onOk&&onOk();
        }
    })
}
const goBack = () => {
    history.goBack();
}
const historyPush = (pathname) => {
    let search = window.location.search
    history.push({pathname: `/fe-pc/b/fe_fitness_user${pathname}/${search}`})
}
const recursionCommonTree = (commonTrees: CommonTree[]) => {
    let tree = commonTrees && commonTrees.length && commonTrees.map(item => {
        if (item.subNodes && item.subNodes.length) {
            let subNodes  = recursionCommonTree(item.subNodes)
            return {
                ...new CommonTree(item),
                subNodes
            }
        } else {
            return new CommonTree(item)
        }
    })
    return tree
}
const handleEnum = (enmuData: KeyValue[]) =>{
    let obj = {}
    enmuData && enmuData.length && enmuData.map(item => {
        obj[item.key] =  item.value
    })
    console.log(obj)
    return obj
}
// 获取URL中的所有参数
const getParamsByUrl = () => {
    const obj = {}
    if (window.location.search) {
      const params = window.location.search.split('?')[1].split('&')
      for (let i = 0; i < params.length; i++) {
        obj[params[i].split('=')[0]] = params[i].split('=')[1]
      }
    }
    return obj
  }
 // 存储system_partition_gId
const saveSystemPartitionGid = (props) => {
    console.log(props)
    if(props.location.search) {
        let params = props.location.search;
        if(params && params.indexOf('system_partition_gId')) {
            let paramArr = params.split('?')[1].split('=')
            if(paramArr.length && paramArr[1]) {
                sessionStorage.setItem('groupId',paramArr[1])
                return paramArr[1]
            }
        }
    }
    else {
        let params = props.location.pathname;
        if(params && params.indexOf('system_partition_gId')) {
            let paramArr = params.split('?')[1].split('=')
            if(paramArr.length && paramArr[1]) {
                sessionStorage.setItem('groupId',paramArr[1])
                return paramArr[1]
            }
        } 
    }
}
// 获取system_partition_gId
const getSystemPartitionGid = () => {
    return sessionStorage.getItem('groupId') || ''
} 
const getFileDuration = (val: number) => {
    if(val<60){
        return val + "秒";
    }else{
        let min_total = Math.floor(val / 60); // 分钟
        let sec = Math.floor(val % 60); // 余秒
        if(min_total<60){
            return min_total + "分钟" + sec + "秒";
        }else{
            let hour_total = Math.floor(min_total / 60); // 小时数
            let min = Math.floor(min_total % 60); // 余分钟
            return hour_total + "小时" + min + "分钟" + sec + "秒";
        }
    }
}
const getFileSize = (limit: number) => {
    var size = "";  
    if( limit < 0.1 * 1000 ){ //如果小于0.1KB转化成B
        size = limit.toFixed(2) + "B";    
     }else if(limit < 0.1 * 1000 * 1000 ){//如果小于0.1MB转化成KB  
        size = (limit / 1000).toFixed(2) + "KB";              
     }else if(limit < 0.1 * 1000 * 1000 * 1000){ //如果小于0.1GB转化成MB  
         size = (limit / (1000 * 1000)).toFixed(2) + "MB";  
     }else{ //其他转化成GB  
         size = (limit / (1000 * 1000 * 1000)).toFixed(2) + "GB";  
    }            
    var sizestr = size + "";   
    var len = sizestr.indexOf("\.");  
    var dec = sizestr.substr(len + 1, 2);  
    if(dec == "00"){//当小数点后为00时 去掉小数部分  
        return sizestr.substring(0,len) + sizestr.substr(len + 3,2);  
    }  
    return sizestr;
}
// 根据文件后缀名获取文件的类型（VIDEO、AUDIO、PICTURE、LINK、DOCUMENT、ZIP）
const getResourceType = (suffix: string) => {
    if (new RegExp('(.jpg|.png|.jpeg|.gif)$').test(suffix)) {
        return 'PICTURE'
    } else if (new RegExp('(.mp4|.flv|.avi|.mov|.mkv|.m4v|.ts)$').test(suffix)) {
        return 'VIDEO'
    } else if (new RegExp('(.mp3|.flac|.m4a|.ogg)$').test(suffix)) {
        return 'AUDIO'
    } else if (new RegExp('(.doc|.docx|.xls|.xlsx|.ppt|.pptx|.pdf|.txt|.json)$').test(suffix)) {
        return 'DOCUMENT'
    } else if (new RegExp('(.rar|.zip|.tar)$').test(suffix)) {
        return 'ZIP'
    } else if (new RegExp('(.url)$').test(suffix)) {
        return 'LINK'
    }
}
const getDateZeroTime = (date) => {
    if (typeof date == 'undefined') {
        throw new Error('date is undefined!');
    }
     
    if (typeof date == 'number') {
        return new Date(new Date(date).toLocaleDateString()).getTime()
    }
     
    if (typeof date == 'object') {
        return new Date(date.toLocaleDateString()).getTime()
    }
}
// 根据时间戳获取周一零点时间戳
const getWeekFirstDayDateZeroTime = (date: any) => {
    let nowTemp = new Date(date);
    let oneDayLong = 24 * 60 * 60 * 1000
    let c_time = nowTemp.getTime() ;
    let c_day = nowTemp.getDay() || 7; // 当前时间的星期几
    let m_time = c_time - (c_day - 1) * oneDayLong; // 当前周一的毫秒时间
    let result = getDateZeroTime(m_time) // 当前周一0点时间戳
    console.log(result)
    return result
}

// 生成pv埋点数据
const generateEventTracking = (fe_path: string, id: string, eventTime: number) => {
    let {location} = window
    let groupId = ''
    if (location.search) {
        let params = Qs.parse(location.search.split('?')[1])
        groupId = params.system_partition_gId ? String(params.system_partition_gId): ''
    }
    // 初始化当前页面的埋点数据
    let etBaseDataModel = new ETBaseDataModel({
        eventTime,
        groupId,
        extraType: 1,
        extraData: JSON.stringify({ 
            fe_path, id, 
            stay_time: Number((((+new Date())- eventTime)/1000).toFixed(2)), 
            original_path: location.pathname + location.search 
        })
    })
    return etBaseDataModel
}
// 生成视频音频埋点数据
const generateMediaEventTracking = (extraData:MediaExtradata, uId) => {
    let {location} = window
    let groupId = ''
    if (location.search) {
        let params = Qs.parse(location.search.split('?')[1])
        groupId = params.system_partition_gId ? String(params.system_partition_gId): ''
    }
    // 初始化当前页面的埋点数据
    let etBaseDataModel = new ETBaseDataModel({
        eventTime: (+new Date()),
        groupId,
        uId,
        extraType: 2,
        extraData: JSON.stringify(extraData)
    })
    return etBaseDataModel
}
// 将阿拉伯数字转换为中文大写
const Arabia_To_SimplifiedChinese = (Num) => {
    for (let i = Num.length - 1; i >= 0; i--) {
        Num = Num.replace(",", "")//替换Num中的“,”
        Num = Num.replace(" ", "")//替换Num中的空格
    }    
    if (isNaN(Num)) { //验证输入的字符是否为数字
        //alert("请检查小写金额是否正确");
        return;
    }
    //字符处理完毕后开始转换，采用前后两部分分别转换
    let part = String(Num).split(".");
    let newchar = "";
    //小数点前进行转化
    for (let i = part[0].length - 1; i >= 0; i--) {
        if (part[0].length > 10) {
            //alert("位数过大，无法计算");
            return "";
        }//若数量超过拾亿单位，提示
        let tmpnewchar = ""
        let perchar = part[0].charAt(i);
        switch (perchar) {
            case "0":  tmpnewchar = "零" + tmpnewchar;break;
            case "1": tmpnewchar = "一" + tmpnewchar; break;
            case "2": tmpnewchar = "二" + tmpnewchar; break;
            case "3": tmpnewchar = "三" + tmpnewchar; break;
            case "4": tmpnewchar = "四" + tmpnewchar; break;
            case "5": tmpnewchar = "五" + tmpnewchar; break;
            case "6": tmpnewchar = "六" + tmpnewchar; break;
            case "7": tmpnewchar = "七" + tmpnewchar; break;
            case "8": tmpnewchar = "八" + tmpnewchar; break;
            case "9": tmpnewchar = "九" + tmpnewchar; break;
        }
        switch (part[0].length - i - 1) {
            case 0: tmpnewchar = tmpnewchar; break;
            case 1: if (Number(perchar) != 0) tmpnewchar = tmpnewchar + "十"; break;
            case 2: if (Number(perchar) != 0) tmpnewchar = tmpnewchar + "百"; break;
            case 3: if (Number(perchar) != 0) tmpnewchar = tmpnewchar + "千"; break;
            case 4: tmpnewchar = tmpnewchar + "万"; break;
            case 5: if (Number(perchar) != 0) tmpnewchar = tmpnewchar + "十"; break;
            case 6: if (Number(perchar) != 0) tmpnewchar = tmpnewchar + "百"; break;
            case 7: if (Number(perchar) != 0) tmpnewchar = tmpnewchar + "千"; break;
            case 8: tmpnewchar = tmpnewchar + "亿"; break;
            case 9: tmpnewchar = tmpnewchar + "十"; break;
        }
        newchar = tmpnewchar + newchar;
    }   
    //替换所有无用汉字，直到没有此类无用的数字为止
    while (newchar.search("零零") != -1 || newchar.search("零亿") != -1 || newchar.search("亿万") != -1 || newchar.search("零万") != -1) {
        newchar = newchar.replace("零亿", "亿");
        newchar = newchar.replace("亿万", "亿");
        newchar = newchar.replace("零万", "万");
        newchar = newchar.replace("零零", "零");      
    }
    //替换以“一十”开头的，为“十”
    if (newchar.indexOf("一十") == 0) {
        newchar = newchar.substr(1);
    }
    //替换以“零”结尾的，为“”
    if (newchar.lastIndexOf("零") == newchar.length - 1) {
        newchar = newchar.substr(0, newchar.length - 1);
    }
    return newchar;
}
// 将文件转换为流并下载
const downloadFileOfBlob = (path, name) => {
    try {
        const xhr = new XMLHttpRequest();
        xhr.open('get', path);
        xhr.responseType = 'blob';
        xhr.send();
        xhr.onload = function () {
            if (this.status === 200 || this.status === 304) {
                // 如果是IE10及以上，不支持download属性，采用msSaveOrOpenBlob方法，但是IE10以下也不支持msSaveOrOpenBlob
                if ('msSaveOrOpenBlob' in navigator) {
                    navigator['msSaveOrOpenBlob'](this.response, name);
                    return;
                }
                // const blob = new Blob([this.response], { type: xhr.getResponseHeader('Content-Type') });
                // const url = URL.createObjectURL(blob);
                const url = URL.createObjectURL(this.response);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = name;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            }
        }
    } catch {
        console.log('下载失败')
    }
    
}
// 埋点数据上报
const eventTrackingReport = (url, eventTrackingData) => {
    let token = Cookies.get('token')
    let groupId = null 
    let baseUrl = process.env.REACT_APP_ENV === 'production' ? 'https://prod-api.dbxiao.com' :(process.env.REACT_APP_ENV === 'test' ? 'https://api-test.dbxiao.cn': '') 
    if (window.location.search) {
        let params = Qs.parse(window.location.search.split('?')[1])
        groupId = params.system_partition_gId ? String(params.system_partition_gId): ''
    }
    return new Promise((resolve, reject) => {
        fetch(`${baseUrl}${url}`, {
            method: 'POST',
            body: JSON.stringify({data: eventTrackingData}),
            keepalive: true,
            headers: {
                token,
                groupId
            }
        }).then(() => {
            resolve('success')
        }).catch(() => {
        reject('error')
        })
    })
}


export {confirmOperate, goBack, recursionCommonTree,
        handleEnum, getParamsByUrl, saveSystemPartitionGid, getSystemPartitionGid,
        getFileDuration, getFileSize, getResourceType, getWeekFirstDayDateZeroTime,
        generateEventTracking, generateMediaEventTracking, Arabia_To_SimplifiedChinese,
        downloadFileOfBlob, eventTrackingReport}
